import { useMutation } from '@tanstack/react-query';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import snackbarStore from '../../../stores/Snackbar.store';
import { brandShowroomRepository } from './brand-showroom.repository';
import { BrandShowroomAbout, BrandShowroomBanner } from './brand-showroom.types';

interface SaveShowroomAboutParams {
  about: BrandShowroomAbout;
  banner?: BrandShowroomBanner;
}

interface UseSaveShowroomAboutMutationParams {
  onSuccess: () => void;
}

const repository = brandShowroomRepository();

export const useSaveShowroomAboutMutation = ({ onSuccess }: UseSaveShowroomAboutMutationParams) => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const { isPending, mutate: saveAbout } = useMutation({
    mutationFn: async ({ about, banner }: SaveShowroomAboutParams) => {
      const aboutResponse = await repository.saveAbout(about);

      if (!aboutResponse.ok) {
        throw aboutResponse.originalError ?? new Error(LangEnum.SHOWROOM_ERROR);
      }

      if (!banner) {
        return;
      }

      const bannerResponse = await repository.saveBanner(banner);

      if (!bannerResponse.ok) {
        throw bannerResponse.originalError ?? new Error(LangEnum.SHOWROOM_ERROR);
      }
    },
    onSuccess,
    onError: () => {
      handleMessage({ type: 'error', message: translate(LangEnum.SHOWROOM_ERROR) });
    },
  });

  return { isPending, saveAbout };
};
